import React from 'react';
import { Container, Row, Col, Button } from 'reactstrap';

import "./EquipmentChecklistPreview.css"

const EquipmentChecklistPreview = (props) => {

    const showVar = (str) => {
        return str === '' || str == null ? <>&nbsp;</> : str;
    }

    const formatDate = (date) => {
        return parseInt(new Date(date).toISOString().substring(5, 7)) + '/' + parseInt(new Date(date).toISOString().substring(8, 10)) + '/' + new Date(date).toISOString().substring(0, 4);
    }

    const formatTime = (time) => {
        const [hourStr, minute] = time.split(":");
        let hour = parseInt(hourStr, 10);
        const ampm = hour >= 12 ? "PM" : "AM";
        hour = hour % 12;
        hour = hour === 0 ? 12 : hour;
        return `${hour}:${minute} ${ampm}`;
    }

    return (
        <div id="">
            <Container>
                <Row className='m-4 text-center'>
                    <Col>
                        <Button onClick={showVar(props.hidePreview)} color="secondary">Close</Button>
                    </Col>
                </Row>
            </Container>
            <div id="equipmentChecklistPreviewContainer" className="page-container">
                <div
                    id="html"
                    className="page-container"
                    style={{
                        padding: 25,
                        backgroundColor: "#fff",
                        width: 720,
                        margin: "0 auto",
                        boxShadow: "3px 3px 10px rgba(0,0,0,.5)"
                    }}
                >
                    <div
                        className="page"
                        style={{ pageBreakAfter: "always", width: "auto", margin: "auto" }}
                    >
                        <table
                            width="100%"
                            border={0}
                            cellSpacing={0}
                            cellPadding={0}
                            id="header"
                            style={{ fontFamily: "Arial, Helvetica, sans-serif" }}
                        >
                            <tbody>
                                <tr>
                                    <td
                                        id="mailingAddress"
                                        style={{ verticalAlign: "middle", width: "25%", fontSize: 9 }}
                                    >
                                        <p style={{ fontSize: 10, marginTop: 7 }}>
                                            Mailing Address:
                                            <br />
                                            <span
                                                className="uppercase"
                                                style={{ textTransform: "uppercase" }}
                                            >
                                                P.O. Box 1867
                                                <br />
                                                Lodi, CA 95241
                                            </span>
                                        </p>
                                        <p style={{ fontSize: 10, marginTop: 7 }}>
                                            Physical Address:
                                            <br />
                                            <span
                                                className="uppercase"
                                                style={{ textTransform: "uppercase" }}
                                            >
                                                1030 N Guild Ave
                                                <br />
                                                Lodi, CA 95240
                                            </span>
                                        </p>
                                    </td>
                                    <td
                                        id="logoArea"
                                        style={{
                                            verticalAlign: "middle",
                                            width: "50%",
                                            textAlign: "center",
                                            fontSize: 9
                                        }}
                                    >
                                        <img
                                            src={props.logo}
                                            alt="Logo"
                                            id="logo"
                                            style={{ height: 80 }}
                                        />
                                        <br />
                                        California Contractors License# 404723
                                    </td>
                                    <td
                                        id="phoneArea"
                                        style={{
                                            verticalAlign: "middle",
                                            width: "25%",
                                            textAlign: "right",
                                            fontSize: 10
                                        }}
                                    >
                                        Lodi (209) 333-0136
                                        <br />
                                        Fax (209) 333-0993
                                        <br />
                                        www.amstephens.net
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <h1
                            style={{ fontSize: 30, textDecoration: "underline", textAlign: "center", fontWeight: 700 }}
                        >
                            Equipment Checklist
                        </h1>
                        <table
                            border={0}
                            cellSpacing={0}
                            cellPadding={0}
                            id="job-area"
                            style={{ width: "90%", margin: "0 auto", fontSize: 18 }}
                        >
                            <tbody>
                                <tr>
                                    <td
                                        id="Date-label"
                                        style={{
                                            verticalAlign: "bottom",
                                            width: "7%",
                                            textAlign: "right",
                                            paddingRight: "2%",
                                            fontSize: 18
                                        }}
                                    >
                                        Date:
                                    </td>
                                    <td
                                        id="Date-field"
                                        className="textfield"
                                        style={{
                                            verticalAlign: "bottom",
                                            borderBottom: "1px solid #000",
                                            marginRight: "5%",
                                            fontFamily: "Arial, Helvetica, sans-serif",
                                            width: "12%",
                                            fontSize: 16
                                        }}
                                    >
                                        {showVar(formatDate(props.Date))}
                                    </td>
                                    <td className="spacer" style={{ verticalAlign: "bottom" }}>
                                        &nbsp;
                                    </td>
                                    <td
                                        id="Time-label"
                                        style={{
                                            verticalAlign: "bottom",
                                            width: "8%",
                                            textAlign: "right",
                                            paddingRight: "2%",
                                            fontSize: 18
                                        }}
                                    >
                                        Time:
                                    </td>
                                    <td
                                        id="Time-field"
                                        className="textfield"
                                        style={{
                                            verticalAlign: "bottom",
                                            borderBottom: "1px solid #000",
                                            marginRight: "5%",
                                            fontFamily: "Arial, Helvetica, sans-serif",
                                            width: "12%",
                                            fontSize: 16
                                        }}
                                    >
                                        {showVar(formatTime(props.Time))}
                                    </td>
                                    <td className="spacer" style={{ verticalAlign: "bottom" }}>
                                        &nbsp;
                                    </td>
                                    <td
                                        id="EquipmentNo-label"
                                        style={{
                                            verticalAlign: "bottom",
                                            width: "13%",
                                            textAlign: "right",
                                            paddingRight: "2%",
                                            fontSize: 18
                                        }}
                                    >
                                        Equip #:
                                    </td>
                                    <td
                                        id="EquipNo-field"
                                        className="textfield"
                                        style={{
                                            verticalAlign: "bottom",
                                            borderBottom: "1px solid #000",
                                            marginRight: "5%",
                                            fontFamily: "Arial, Helvetica, sans-serif",
                                            width: "20%",
                                            fontSize: 14
                                        }}
                                    >
                                        {showVar(props.EquipmentNo)}
                                    </td>
                                    <td className="spacer" style={{ verticalAlign: "bottom" }}>
                                        &nbsp;
                                    </td>
                                    <td
                                        id="JobName-label"
                                        style={{
                                            verticalAlign: "bottom",
                                            width: "16%",
                                            textAlign: "right",
                                            paddingRight: "2%",
                                            fontSize: 18
                                        }}
                                    >
                                        Job Name:
                                    </td>
                                    <td
                                        id="JobName-field"
                                        className="textfield"
                                        style={{
                                            verticalAlign: "bottom",
                                            borderBottom: "1px solid #000",
                                            marginRight: "5%",
                                            fontFamily: "Arial, Helvetica, sans-serif",
                                            width: "20%",
                                            fontSize: 14
                                        }}
                                    >
                                        {showVar(props.JobName)}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <table
                            cellSpacing={5}
                            cellPadding={0}
                            id="a-questions"
                            style={{ width: "100%", marginLeft: "0%", fontSize: 14, marginTop: 10 }}
                        >
                            <tbody>
                                <tr>
                                    <td id="a-questions-title" style={{ verticalAlign: "bottom", width: "25%" }}>
                                        {/* Equipment Name */}
                                    </td>
                                    <td id="a-questions-yes" style={{ verticalAlign: "bottom", width: "5%", textTransform: "uppercase" }} >
                                        Yes
                                    </td>
                                    <td className="spacer" style={{ verticalAlign: "bottom" }}>
                                        &nbsp;
                                    </td>
                                    <td id="a-questions-no" style={{ verticalAlign: "bottom", width: "5%", textTransform: "uppercase" }}>
                                        No
                                    </td>
                                    <td className="spacer" style={{ verticalAlign: "bottom" }}>
                                        &nbsp;
                                    </td>
                                    <td id="a-questions-comment" style={{ verticalAlign: "bottom", width: "65%" }} >
                                        Comment
                                    </td>
                                </tr>
                                {[...Array(16).keys()]
                                    .filter(item => {
                                        const name = props[`Equipment${item + 1}Name`];
                                        const yesno = props[`Equipment${item + 1}YesNo`];
                                        const comment = props[`Equipment${item + 1}Comment`];
                                        return name || yesno || comment;
                                    })
                                    .map(item => (
                                        <tr>
                                            <td>{showVar(props[`Equipment${item + 1}Name`])}</td>
                                            <td
                                                className="textfield yesno"
                                                style={{
                                                    verticalAlign: "bottom",
                                                    borderBottom: "1px solid #000",
                                                    paddingRight: "1%",
                                                    fontFamily: "Arial, Helvetica, sans-serif",
                                                    textAlign: "center"
                                                }}>
                                                {showVar(props[`Equipment${item + 1}YesNo`]) === true ? 'X' : ''}
                                            </td>
                                            <td style={{ verticalAlign: "bottom" }}>&nbsp;</td>
                                            <td
                                                className="textfield yesno"
                                                style={{
                                                    verticalAlign: "bottom",
                                                    borderBottom: "1px solid #000",
                                                    paddingRight: "1%",
                                                    fontFamily: "Arial, Helvetica, sans-serif",
                                                    textAlign: "center"
                                                }}>
                                                {showVar(props[`Equipment${item + 1}YesNo`]) === false ? 'X' : ''}
                                            </td>
                                            <td style={{ verticalAlign: "bottom" }}>&nbsp;</td>
                                            <td>{showVar(props[`Equipment${item + 1}Comment`])}</td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                        <table
                            border={0}
                            cellSpacing={0}
                            cellPadding={0}
                            id="signature-area"
                            style={{ width: "50%", marginLeft: "50%", fontSize: 14 }}
                        >
                            <tbody>
                                <tr>
                                    <td
                                        id="Signature-label"
                                        style={{
                                            verticalAlign: "bottom",
                                            width: "50%",
                                            textAlign: "right"
                                        }}
                                    >
                                        Signature:
                                    </td>
                                    <td
                                        id="Signature-field"
                                        className="textfield"
                                        style={{
                                            verticalAlign: "bottom",
                                            borderBottom: "1px solid #000",
                                            marginRight: "5%",
                                            fontFamily: "Arial, Helvetica, sans-serif",
                                            width: "50%"
                                        }}
                                    >
                                        {props.Signature && <img
                                            src={showVar(props.Signature)}
                                            alt="Signature"
                                            className='signature'
                                        />}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        {/* <table
                            border={0}
                            cellSpacing={0}
                            cellPadding={0}
                            id="daily-comments-area"
                            style={{ width: "100%", fontSize: 14 }}
                        >
                            <tbody>
                                <tr>
                                    <td
                                        id="DailyComments-label"
                                        style={{ verticalAlign: "top", width: "25%", textAlign: "left" }}
                                    >
                                        Daily Comments on Safety:
                                    </td>
                                    <td
                                        id="DailyComments-field"
                                        className="textfield-noborder"
                                        style={{
                                            verticalAlign: "top",
                                            marginRight: "5%",
                                            fontFamily: "Arial, Helvetica, sans-serif",
                                            width: "75%",
                                            paddingLeft: "5%",
                                            textAlign: "left",
                                            height: 40
                                        }}
                                    >
                                        {showVar(props.SafetyComments)}
                                    </td>
                                </tr>
                            </tbody>
                        </table> */}
                        {/* <p style={{ fontSize: 14, marginTop: 7 }}>
                            Daily Heat Illness Prevention: (Each employee must read and sign this
                            section daily)
                        </p> */}
                        {/* <table
                            cellSpacing={0}
                            cellPadding={0}
                            id="b-questions"
                            style={{ width: "90%", marginLeft: "10%", fontSize: 14, marginTop: 10 }}
                        >
                            <tbody>
                                <tr>
                                    <td
                                        id="b-questions-title"
                                        style={{ verticalAlign: "bottom", width: "75%" }}
                                    >
                                        &nbsp;
                                    </td>
                                    <td
                                        id="b-questions-yes"
                                        style={{
                                            verticalAlign: "bottom",
                                            width: "10%",
                                            textTransform: "uppercase"
                                        }}
                                    >
                                        Yes
                                    </td>
                                    <td className="spacer" style={{ verticalAlign: "bottom" }}>
                                        &nbsp;
                                    </td>
                                    <td
                                        id="b-questions-no"
                                        style={{
                                            verticalAlign: "bottom",
                                            width: "10%",
                                            textTransform: "uppercase"
                                        }}
                                    >
                                        No
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ verticalAlign: "bottom" }}>
                                        1. Are there provisions for water on the job site?
                                    </td>
                                    <td
                                        className="textfield yesno"
                                        style={{
                                            verticalAlign: "bottom",
                                            borderBottom: "1px solid #000",
                                            marginRight: "5%",
                                            fontFamily: "Arial, Helvetica, sans-serif",
                                            textAlign: "center"
                                        }}
                                    >
                                        {showVar(props.QuestionB1) ? 'X' : ''}
                                    </td>
                                    <td style={{ verticalAlign: "bottom" }}>&nbsp;</td>
                                    <td
                                        className="textfield yesno"
                                        style={{
                                            verticalAlign: "bottom",
                                            borderBottom: "1px solid #000",
                                            marginRight: "5%",
                                            fontFamily: "Arial, Helvetica, sans-serif",
                                            textAlign: "center"
                                        }}
                                    >
                                        {!showVar(props.QuestionB1) ? 'X' : ''}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ verticalAlign: "bottom" }}>
                                        2. Do you know where your access to shade is?
                                    </td>
                                    <td
                                        className="textfield yesno"
                                        style={{
                                            verticalAlign: "bottom",
                                            borderBottom: "1px solid #000",
                                            marginRight: "5%",
                                            fontFamily: "Arial, Helvetica, sans-serif",
                                            textAlign: "center"
                                        }}
                                    >
                                        {showVar(props.QuestionB2) ? 'X' : ''}
                                    </td>
                                    <td style={{ verticalAlign: "bottom" }}>&nbsp;</td>
                                    <td
                                        className="textfield yesno"
                                        style={{
                                            verticalAlign: "bottom",
                                            borderBottom: "1px solid #000",
                                            marginRight: "5%",
                                            fontFamily: "Arial, Helvetica, sans-serif",
                                            textAlign: "center"
                                        }}
                                    >
                                        {!showVar(props.QuestionB2) ? 'X' : ''}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ verticalAlign: "bottom" }}>
                                        3. Do you know what to do during a heat wave?
                                    </td>
                                    <td
                                        className="textfield yesno"
                                        style={{
                                            verticalAlign: "bottom",
                                            borderBottom: "1px solid #000",
                                            marginRight: "5%",
                                            fontFamily: "Arial, Helvetica, sans-serif",
                                            textAlign: "center"
                                        }}
                                    >
                                        {showVar(props.QuestionB3) ? 'X' : ''}
                                    </td>
                                    <td style={{ verticalAlign: "bottom" }}>&nbsp;</td>
                                    <td
                                        className="textfield yesno"
                                        style={{
                                            verticalAlign: "bottom",
                                            borderBottom: "1px solid #000",
                                            marginRight: "5%",
                                            fontFamily: "Arial, Helvetica, sans-serif",
                                            textAlign: "center"
                                        }}
                                    >
                                        {!showVar(props.QuestionB3) ? 'X' : ''}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ verticalAlign: "bottom" }}>
                                        4. Are you informed of the AM Stephens high heat procedures?
                                    </td>
                                    <td
                                        className="textfield yesno"
                                        style={{
                                            verticalAlign: "bottom",
                                            borderBottom: "1px solid #000",
                                            marginRight: "5%",
                                            fontFamily: "Arial, Helvetica, sans-serif",
                                            textAlign: "center"
                                        }}
                                    >
                                        {showVar(props.QuestionB4) ? 'X' : ''}
                                    </td>
                                    <td style={{ verticalAlign: "bottom" }}>&nbsp;</td>
                                    <td
                                        className="textfield yesno"
                                        style={{
                                            verticalAlign: "bottom",
                                            borderBottom: "1px solid #000",
                                            marginRight: "5%",
                                            fontFamily: "Arial, Helvetica, sans-serif",
                                            textAlign: "center"
                                        }}
                                    >
                                        {!showVar(props.QuestionB4) ? 'X' : ''}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ verticalAlign: "bottom" }}>
                                        5. Are you informed of AM Stephens heat acclimation procedures?
                                    </td>
                                    <td
                                        className="textfield yesno"
                                        style={{
                                            verticalAlign: "bottom",
                                            borderBottom: "1px solid #000",
                                            marginRight: "5%",
                                            fontFamily: "Arial, Helvetica, sans-serif",
                                            textAlign: "center"
                                        }}
                                    >
                                        {showVar(props.QuestionB5) ? 'X' : ''}
                                    </td>
                                    <td style={{ verticalAlign: "bottom" }}>&nbsp;</td>
                                    <td
                                        className="textfield yesno"
                                        style={{
                                            verticalAlign: "bottom",
                                            borderBottom: "1px solid #000",
                                            marginRight: "5%",
                                            fontFamily: "Arial, Helvetica, sans-serif",
                                            textAlign: "center"
                                        }}
                                    >
                                        {!showVar(props.QuestionB5) ? 'X' : ''}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ verticalAlign: "bottom" }}>
                                        6. Are you informed of the AM Stephens Emergency response rules?
                                    </td>
                                    <td
                                        className="textfield yesno"
                                        style={{
                                            verticalAlign: "bottom",
                                            borderBottom: "1px solid #000",
                                            marginRight: "5%",
                                            fontFamily: "Arial, Helvetica, sans-serif",
                                            textAlign: "center"
                                        }}
                                    >
                                        {showVar(props.QuestionB6) ? 'X' : ''}
                                    </td>
                                    <td style={{ verticalAlign: "bottom" }}>&nbsp;</td>
                                    <td
                                        className="textfield yesno"
                                        style={{
                                            verticalAlign: "bottom",
                                            borderBottom: "1px solid #000",
                                            marginRight: "5%",
                                            fontFamily: "Arial, Helvetica, sans-serif",
                                            textAlign: "center"
                                        }}
                                    >
                                        {!showVar(props.QuestionB6) ? 'X' : ''}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ verticalAlign: "bottom" }}>
                                        7. Are you informed of how AM Stephens handles a sick employee?
                                    </td>
                                    <td
                                        className="textfield yesno"
                                        style={{
                                            verticalAlign: "bottom",
                                            borderBottom: "1px solid #000",
                                            marginRight: "5%",
                                            fontFamily: "Arial, Helvetica, sans-serif",
                                            textAlign: "center"
                                        }}
                                    >
                                        {showVar(props.QuestionB7) ? 'X' : ''}
                                    </td>
                                    <td style={{ verticalAlign: "bottom" }}>&nbsp;</td>
                                    <td
                                        className="textfield yesno"
                                        style={{
                                            verticalAlign: "bottom",
                                            borderBottom: "1px solid #000",
                                            marginRight: "5%",
                                            fontFamily: "Arial, Helvetica, sans-serif",
                                            textAlign: "center"
                                        }}
                                    >
                                        {!showVar(props.QuestionB7) ? 'X' : ''}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ verticalAlign: "bottom" }}>
                                        8. Are you informed of the AM Stephens employee and supervisory training?
                                    </td>
                                    <td
                                        className="textfield yesno"
                                        style={{
                                            verticalAlign: "bottom",
                                            borderBottom: "1px solid #000",
                                            marginRight: "5%",
                                            fontFamily: "Arial, Helvetica, sans-serif",
                                            textAlign: "center"
                                        }}
                                    >
                                        {showVar(props.QuestionB8) ? 'X' : ''}
                                    </td>
                                    <td style={{ verticalAlign: "bottom" }}>&nbsp;</td>
                                    <td
                                        className="textfield yesno"
                                        style={{
                                            verticalAlign: "bottom",
                                            borderBottom: "1px solid #000",
                                            marginRight: "5%",
                                            fontFamily: "Arial, Helvetica, sans-serif",
                                            textAlign: "center"
                                        }}
                                    >
                                        {!showVar(props.QuestionB8) ? 'X' : ''}
                                    </td>
                                </tr>
                            </tbody>
                        </table> */}
                        {/* <p style={{ fontSize: 14, marginTop: 7 }}>
                            If you answered <u>YES</u> to the questions above, please sign below.
                            If you answered <u>NO</u>, AM Stephens requests that you contact your supervisor immediately to address and resolve any issues.{" "}
                        </p> */}
                        {/* <table
                            cellSpacing={5}
                            cellPadding={0}
                            id="employee-signature-area"
                            style={{ width: "100%", borderSpacing: 5, borderCollapse: 0 }}
                        >
                            <tbody>
                                <tr>
                                    <td
                                        className="textfield"
                                        style={{
                                            verticalAlign: "bottom",
                                            borderBottom: "1px solid #000",
                                            marginRight: "5%",
                                            fontFamily: "Arial, Helvetica, sans-serif",
                                            width: "33%",
                                            height: 30
                                        }}
                                    >
                                        {props.EmployeeSignature1 && <img
                                            src={showVar(props.EmployeeSignature1)}
                                            alt="Employee Signature 1"
                                            className='signature'
                                        />}
                                    </td>
                                    <td
                                        className="textfield"
                                        style={{
                                            verticalAlign: "bottom",
                                            borderBottom: "1px solid #000",
                                            marginRight: "5%",
                                            fontFamily: "Arial, Helvetica, sans-serif",
                                            width: "33%",
                                            height: 30
                                        }}
                                    >
                                        {props.EmployeeSignature2 && <img
                                            src={showVar(props.EmployeeSignature2)}
                                            alt="Employee Signature 2"
                                            className='signature'
                                        />}
                                    </td>
                                    <td
                                        className="textfield"
                                        style={{
                                            verticalAlign: "bottom",
                                            borderBottom: "1px solid #000",
                                            marginRight: "5%",
                                            fontFamily: "Arial, Helvetica, sans-serif",
                                            width: "33%",
                                            height: 30
                                        }}
                                    >
                                        {props.EmployeeSignature3 && <img
                                            src={showVar(props.EmployeeSignature3)}
                                            alt="Employee Signature 3"
                                            className='signature'
                                        />}
                                    </td>
                                </tr>
                                <tr>
                                    <td
                                        className="textfield"
                                        style={{
                                            verticalAlign: "bottom",
                                            borderBottom: "1px solid #000",
                                            marginRight: "5%",
                                            fontFamily: "Arial, Helvetica, sans-serif",
                                            width: "33%",
                                            height: 30
                                        }}
                                    >
                                        {props.EmployeeSignature4 && <img
                                            src={showVar(props.EmployeeSignature4)}
                                            alt="Employee Signature 4"
                                            className='signature'
                                        />}
                                    </td>
                                    <td
                                        className="textfield"
                                        style={{
                                            verticalAlign: "bottom",
                                            borderBottom: "1px solid #000",
                                            marginRight: "5%",
                                            fontFamily: "Arial, Helvetica, sans-serif",
                                            width: "33%",
                                            height: 30
                                        }}
                                    >
                                        {props.EmployeeSignature5 && <img
                                            src={showVar(props.EmployeeSignature5)}
                                            alt="Employee Signature 5"
                                            className='signature'
                                        />}
                                    </td>
                                    <td
                                        className="textfield"
                                        style={{
                                            verticalAlign: "bottom",
                                            borderBottom: "1px solid #000",
                                            marginRight: "5%",
                                            fontFamily: "Arial, Helvetica, sans-serif",
                                            width: "33%",
                                            height: 30
                                        }}
                                    >
                                        {props.EmployeeSignature6 && <img
                                            src={showVar(props.EmployeeSignature6)}
                                            alt="Employee Signature 6"
                                            className='signature'
                                        />}
                                    </td>
                                </tr>
                                <tr>
                                    <td
                                        className="textfield"
                                        style={{
                                            verticalAlign: "bottom",
                                            borderBottom: "1px solid #000",
                                            marginRight: "5%",
                                            fontFamily: "Arial, Helvetica, sans-serif",
                                            width: "33%",
                                            height: 30
                                        }}
                                    >
                                        {props.EmployeeSignature7 && <img
                                            src={showVar(props.EmployeeSignature7)}
                                            alt="Employee Signature 7"
                                            className='signature'
                                        />}
                                    </td>
                                    <td
                                        className="textfield"
                                        style={{
                                            verticalAlign: "bottom",
                                            borderBottom: "1px solid #000",
                                            marginRight: "5%",
                                            fontFamily: "Arial, Helvetica, sans-serif",
                                            width: "33%",
                                            height: 30
                                        }}
                                    >
                                        {props.EmployeeSignature8 && <img
                                            src={showVar(props.EmployeeSignature8)}
                                            alt="Employee Signature 8"
                                            className='signature'
                                        />}
                                    </td>
                                    <td
                                        className="textfield"
                                        style={{
                                            verticalAlign: "bottom",
                                            borderBottom: "1px solid #000",
                                            marginRight: "5%",
                                            fontFamily: "Arial, Helvetica, sans-serif",
                                            width: "33%",
                                            height: 30
                                        }}
                                    >
                                        {props.EmployeeSignature9 && <img
                                            src={showVar(props.EmployeeSignature9)}
                                            alt="Employee Signature 9"
                                            className='signature'
                                        />}
                                    </td>
                                </tr>
                            </tbody>
                        </table> */}
                        {/* <table
                            id="equipment-repair-area"
                            cellSpacing={0}
                            cellPadding={0}
                            style={{ width: "100%", fontSize: 14 }}
                        >
                            <tbody>
                                <tr>
                                    <td
                                        id="EquipmentRepair-label"
                                        style={{ verticalAlign: "top", width: "25%", textAlign: "left" }}
                                    >
                                        Equipment Repair:
                                    </td>
                                    <td
                                        id="EquipmentRepair-field"
                                        className="textfield-noborder"
                                        style={{
                                            verticalAlign: "top",
                                            marginRight: "5%",
                                            fontFamily: "Arial, Helvetica, sans-serif",
                                            width: "75%",
                                            paddingLeft: "5%",
                                            textAlign: "left",
                                            height: 40
                                        }}
                                    >
                                        {showVar(props.RepairNeeds)}
                                    </td>
                                </tr>
                            </tbody>
                        </table> */}
                    </div>
                </div>

            </div>

        </div>

    )
}

export default EquipmentChecklistPreview;